export default "__VITE_ASSET__PcoFxIbX__"